import popMdsResult from "../action/popMdsResult";
import searchMdsAction from "../action/searchMdsAction";
import voc from '../action/voc';
import semi from '../action/semi';
import createcom from '../action/createcom';
import viewmds from '../action/viewmds';
import mdsdatarequest from '../action/mdsDataRequest';
import metarial from '../action/metarial';
import semicom from '../action/semicom';
import submet from '../action/submet';
import showSub from '../action/showSub';
import receivemds from '../action/receivemds';
import sendMds from '../action/sendMds';
import preview from "../action/preview";
import analyse from "../action/analyse";
import basicInfo from '../action/basicInfo';
import MDSMaterialCreateAction from '../action/MDSMaterialCreateAction';
import showMaterial from '../action/showMaterial';
import mdssuplier from '../action/mdssuplier';
import customcheck from '../action/customcheck';
import selectMDSAction from '../action/selectMDSAction';
import mdsResult from '../action/mdsResult';
import recoveryanalyse from '../action/recoveryanalyse';
import mdsrecipient from '../action/mdsrecipient';
import mdsValidateAction from '../action/mdsValidateAction';
import global from '../action/global'
import delMds from '../action/delMds'
import passwordChange from '../action/passwordChange'
import announcement from '../action/announcement'
import auxiliaryVerificationTool from '../action/auxiliaryVerificationTool'
import setUp from '../action/setUp'
import close from '../action/close'
import auxiliaryTools from '../action/auxiliaryTools'
import substanceResult from '../action/substanceResult'
import refusedmds from '../action/refusedmds'
import ruleNotice from '../action/ruleNotice'
import publishext from '../action/publishext'
import MDSClassManage from '../action/MDSClassManage'
import enterpriseContactPerson from '../action/enterpriseContactPerson'
import noticeManage from '../action/noticeManage'
import common from '../action/common'
import help from '../action/help'
export default {
  title: "China Automotive Material Data System",
  popMdsResult: popMdsResult.EN,
  searchMdsAction: searchMdsAction.EN,
  voc: voc.EN,
  semi: semi.EN,
  createcom: createcom.EN,
  viewmds: viewmds.EN,
  mdsdataRequest: mdsdatarequest.EN,
  metarial: metarial.EN,
  semicom: semicom.EN,
  submet: submet.EN,
  showSub: showSub.EN,
  receivemds: receivemds.EN,
  preview: preview.EN,
  sendMds: sendMds.EN,
  basicInfo: basicInfo.EN,
  MDSMaterialCreateAction: MDSMaterialCreateAction.EN,
  showMaterial: showMaterial.EN,
  mdssuplier: mdssuplier.EN,
  customcheck: customcheck.EN,
  selectMDSAction: selectMDSAction.EN,
  mdsResult: mdsResult.EN,
  recoveryanalyse: recoveryanalyse.EN,
  mdsrecipient: mdsrecipient.EN,
  mdsValidateAction: mdsValidateAction.EN,
  global: global.EN,
  delMds: delMds.EN,
  passwordChange: passwordChange.EN,
  announcement: announcement.EN,
  auxiliaryVerificationTool: auxiliaryVerificationTool.EN,
  setUp: setUp.EN,
  close: close.EN,
  auxiliaryTools: auxiliaryTools.EN,
  substanceResult: substanceResult.EN,
  refusedmds: refusedmds.EN,
  ruleNotice: ruleNotice.EN,
  publishext:publishext.EN,
  MDSClassManage:MDSClassManage.EN,
  enterpriseContactPerson:enterpriseContactPerson.EN,
  noticeManage:noticeManage.EN,
  common:common.EN,
  help:help.EN,
  receivecompliance: {
    table: 'View the compliance information',
    stautsTable: "View the compliance information"
  },
  route: {
    dashboard: "Dashboard",
    documentation: "Documentation",
    guide: "Guide",
    permission: "Permission",
    pagePermission: "Page Permission",
    rolePermission: "Role Permission",
    directivePermission: "Directive Permission",
    icons: "Icons",
    components: "Components",
    tinymce: "Tinymce",
    markdown: "Markdown",
    jsonEditor: "JSON Editor",
    dndList: "Dnd List",
    splitPane: "SplitPane",
    avatarUpload: "Avatar Upload",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "Mixin",
    backToTop: "Back To Top",
    dragDialog: "Drag Dialog",
    dragSelect: "Drag Select",
    dragKanban: "Drag Kanban",
    charts: "Charts",
    keyboardChart: "Keyboard Chart",
    lineChart: "Line Chart",
    mixChart: "Mix Chart",
    example: "Example",
    nested: "Nested Routes",
    menu1: "Menu 1",
    "menu1-1": "Menu 1-1",
    "menu1-2": "Menu 1-2",
    "menu1-2-1": "Menu 1-2-1",
    "menu1-2-2": "Menu 1-2-2",
    "menu1-3": "Menu 1-3",
    menu2: "Menu 2",
    Table: "Table",
    dynamicTable: "Dynamic Table",
    dragTable: "Drag Table",
    inlineEditTable: "Inline Edit",
    complexTable: "Complex Table",
    tab: "Tab",
    form: "Form",
    createArticle: "Create Article",
    editArticle: "Edit Article",
    articleList: "Article List",
    errorPages: "Error Pages",
    page401: "401",
    page404: "404",
    errorLog: "Error Log",
    excel: "Excel",
    exportExcel: "Export Excel",
    selectExcel: "Export Selected",
    mergeHeader: "Merge Header",
    uploadExcel: "Upload Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "Theme",
    clipboardDemo: "Clipboard",
    i18n: "I18n",
    externalLink: "External Link",
    profile: "Profile",
  },
  navbar: {
    dashboard: "Dashboard",
    github: "Github",
    logOut: "Log Out",
    profile: "Profile",
    theme: "Theme",
    size: "Global Size",
  },
  login: {
    themeSet:'Theme Settings',
    themeBlue:'Blue Theme',
    themeGreen:'Green Theme',
    title: "Login Form",
    welcome: "Welcome to login",
    logIn: "Login",
    username: "User ID",
    password: "Password",
    sign: "Register",
    forgot: "Forgot password",
    copyright: "Copyright(c)： China AutoMotive Technology & Research Center Co., Ltd.",
    userIdForgot: "User ID forgotten",
    language: "Language:",
    remember: "Remember",
    userIdNull: "The user ID can not be blank",
    passwordNull: "The password can not be blank",
    any: "any",
    thirdparty: "Or connect with",
    thirdpartyTips: "Can not be simulated on local, so please combine you own business simulation! ! !",
    slider: "Please drag the slider to the far right",
    successText: "Successful verification",
    sliderVerifyText: "Please slide the slider to verify",
  },
  documentation: {
    documentation: "Documentation",
    github: "Github Repository",
  },
  permission: {
    addRole: "New Role",
    editPermission: "Edit",
    roles: "Your roles",
    switchRoles: "Switch roles",
    tips: "In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.",
    delete: "Delete",
    confirm: "Confirm",
    cancel: "Cancel",
  },
  guide: {
    description: "The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ",
    button: "Show Guide",
  },
  components: {
    documentation: "Documentation",
    tinymceTips: "Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.",
    dropzoneTips: "Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.",
    stickyTips: "when the page is scrolled to the preset position will be sticky on the top.",
    backToTopTips1: "When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner",
    backToTopTips2: "You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally",
    imageUploadTips: "Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.",
  },
  table: {
    dynamicTips1: "Fixed header, sorted by header order",
    dynamicTips2: "Not fixed header, sorted by click order",
    dragTips1: "The default order",
    dragTips2: "The after dragging order",
    title: "Title",
    importance: "Imp",
    type: "Type",
    remark: "Remark",
    search: "Search",
    add: "Add",
    export: "Export",
    reviewer: "reviewer",
    id: "No.",
    date: "Date",
    author: "Author",
    readings: "Readings",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    publish: "Publish",
    draft: "Draft",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    index: "No.",
  },
  example: {
    warning: "Creating and editing pages cannot be cached by keep-alive because keep-alive include does not currently support caching based on routes, so it is currently cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or do not use keep-alive include to cache all pages directly. See details",
  },
  errorLog: {
    tips: "Please click the bug icon in the upper right corner",
    description: "Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.",
    documentation: "Document introduction",
  },
  excel: {
    export: "Export",
    upload:"Export upload",
    selectedExport: "Export Selected Items",
    placeholder: "Please enter the file name (default excel-list)",
  },
  zip: {
    export: "Export",
    placeholder: "Please enter the file name (default file)",
  },
  pdf: {
    tips: "Here we use window.print() to implement the feature of downloading PDF.",
  },
  theme: {
    change: "Change Theme",
    documentation: "Theme documentation",
    tips: "Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.",
  },
  tagsView: {
    refresh: "Refresh",
    close: "Close",
    closeOthers: "Close Others",
    closeAll: "Close All",
  },
  settings: {
    title: "Page style setting",
    theme: "Theme Color",
    tagsView: "Open Tags-View",
    fixedHeader: "Fixed Header",
    sidebarLogo: "Sidebar Logo",
  },
  orgManage: {
    alert: "please select a node first!",
    confirm: "If this department has sub departments, all of them will be deleted. Do you want to continue?",
    successDel: "delete successfully!",
    alertDel: "please select a department first!",
    successSave: "save successfully!",
    alertSave: "please select Enterprise or department to save!",
    alertNoName: "Enterprise/Department Name is required.",
    exist: "The name of Enterprise or department has already existed!",
    depManage: "Enterprise information",
    manage: "Management",
    addDep: "Add",
    delDep: "Delete",
    ent: "Enterprise",
    depUnit: "Department",
    depName: "Department Name",
    engName: "Name in English language",
    frName: "Name in foreign language",
    statusFlagId: "Enterprise Identity",
    agencyCode: "Institution code",
    alertNoOrgCode: "Institution code can not be empty.",
    dunsCode: "DUNS No.",
    country: "Country/Region",
    city: "City",
    address: "Address",
    postCode: "Postal code",
    homepage: "Homepage",
    mainProducts: "Main Business",
    save: "Save",
    depManage2: "Edit enterprise information",
  },
  entorguser: {
    title: "Enterprise users information",
    sechstandard: "Search",
    enterprises: "Enterprise",
    orgname: "Department",
    userstatus: "Active",
    loginname: "Login name",
    username: "Name",
    button: {
      query: "Search",
      create: "Create",
      cancel: "Cancel",
    },
    ok: "Yes",
    no: "No",
    page1: "Display",
    page2: "Item",
    page3: "Page",
    prepage: "Previous Page",
    nextpage: "Next Page",
    view: "View",
    revised: "Modify",
    script: {
      select: "Please select an item!",
    },
    maintitle: "China Automotive Material Data System (CAMDS)",
    statusTitle: "Management>>",
    sendTable: "User",
    null: "Null",
    Serialnumber: "No.",
    orgnameandenterprises: "Enterprise(Department)",
    findallpage: "Total",
    up_download: "Upload/Download Authorization",
    lixian: {
      shouquan: "COS",
    },
  },
  usermessage: {
    title: "Enterprise users information",
    title2: "View User",
    enterprises: "Enterprise:",
    loginnam: "Login name of user:",
    email: "E-mail:",
    username: "Name:",
    telephone: "Telephone No.:",
    fax: "Fax No.:",
    orgname: "Department:",
    button: {
      cancel: "Back",
      save: "Submit",
    },
    seandtitle: "China Automotive Material Data System (CAMDS)",
    title1: "Enterprise user",
    statusTitle: "Management",
    upload: "upload",
    download: "download",
    up_download: ">>Upload/Download Authorization",
    up_download1: "Upload/Download Authorization",
    updateok: "Update Successful!",
    uploaderror: "The enterprise has reached its capacity of authorized upload users",
    downloaderror: "The enterprise has reached its capacity of authorized download users",
    up_downloaderror: "The enterprise has reached its capacity of authorized up-download users",
    unup_download: "The enterprise hasn’t opened up-download function",
    cosset: ">>COS Authorization",
    cosset1: "COS Authorization",
    putong: "Normal user",
    gaoji: "Advanced user",
    pleaseselect: "Please select COS!",
    yiman: {
      putong: "The enterprise has reached its capacity of authorized COS normal users",
      gaoji: "The enterprise has reached its capacity of authorized COS advanced users",
    },
    wugaibian: "No change does not need to save",
    false: "Setting failed",
    permission: "The current enterprise doesn't open the permission of COS!",
  },
  entorguserinput: {
    script: {
      message: {
        chkName: "The name is required.",
        chkEMail: "The E-mail is required.",
        chkEMailC: "The two inputed email addresses are inconsistent, please re-enter!",
        chkEMailgeshi: "The format of E-mail is not correct!",
        chkTelephone: "Telephone No. is required.",
        chkFax: "The fax has to be specified!",
        dateType: "The valid start date and the valid end date can not be blank and shall be the time type.",
        dateFromTo: "The valid end date must be later than the valid start date.",
        select: "Please select at least one organization!",
      },
    },
    title: "User",
    title2: "Modify user",
    create: "Modify user",
    effective: "Active:",
    usermeddage: 'User information: Fields marked with(<span style="color: red;">*</span>) are required!',
    title1: "User",
    statusTitle: "Management>>",
    enterprises: "Enterprise:",
    loginname: "Login name:",
    email: "E-mail:",
    emailConfirm: "E-mail Confirm:",
    username: "Name:",
    telephone: "Telephone No.:",
    fax: "Fax No.:",
    passworddata: "Password data:",
    datefrom: "Valid from:",
    todate: "Valid to:",
    access: "Access Permissions:",
    description: "Description:",
    tomail: "The password of this user has been sent to its E-mail!",
    orgname: "Department:",
    button: {
      save: "Submit",
      back: "Back",
      add: "Add an organization",
      remove: "Remove an organization",
      resetpassword: "Reset the password",
      select: "(Please choose ……)",
    },
    lianxiren: "Is this user the contact person of the chosen organization",
    maintitle: "China Automotive Material Data System (CAMDS)",
    addorg: "Add",
    operation: "Action",
    delect: "Delete",
    myorgisnotdel: "It is not allowed to delete",
    addafter: "The new user Information will be sent to the e-mail address. Please check if the address is correct.!",
    updateisok: "update successful!",
    updataok: "update successful!",
    isAddNewUser1: "The new user ID and password will be sent to the e-mail address ",
    isAddNewUser2: ". Please check if the address is correct. Continue?",
  },
  enterprise: {
    name: "Enterprise name",
    enterprise: "Enterprise",
    search: "Search",
    standardlookup: "Search Criteria",
    department: "Department",
    enterpriseidentifier: "Enterprise ID:",
    identifierorganization: "Enterprise/Department-ID:",
    departmentName: "Department name",
    city: "City",
    user: "User Name",
    DUNScoding: "DUNS Number",
    useridentifier: "User LoginName",
    postalcode: "Postal code",
    oCode: "Institution code",
    country: "Country/Region",
    number: "No.",
    see: "View",
    adoption: "Apply",
    return: "OK",
    cancel: "Cancel",
    identifier: "ID",
    mustSelect: "Please select a query result first!",
    detail: "Enterprise details",
    date: "Enterprise information",
    englishName: "English Name",
    foreignLanguage: "Foreign Name",
    post: "Address",
    one: "You must fill in one of these items",
  },
  updownloadnums: {
    orgname: "Enterprise Name",
    uploadusers: "Upload Users",
    downloadusers: "Download Users",
    inputorgname: "Please Input The Enterprise Name!",
    selorgname: "Please Select The Enterprise Name!",
    entUpDownSet: "Enterprise upload/download permission settings",
    index: "No.",
  },
  statistics: {
    EnterpriseName: "EnterpriseName",
    EnterpriseID: "EnterpriseID",
    EnterpriseManager: "EnterpriseManager",
    UpDownNum: "Upload/Download User number",
    UploadUserNum: "UploadUserNum :",
    DownloadUserNum: "DownloadUserNum :",
    Number: "Number",
    EntUploadToalCount: "EnterpriseUploadCount",
    UserName: "UserName",
    UploadMDSNum: "UploadMDSNum",
    UploadMDSCount: "UploadMDSCount",
    DownloadMDSNum: "DownloadMDSNum",
  },
  org: {
    search: "SearchTime",
    start: "StartTime",
    end: "EndTime",
    txt: {
      approve: "Approve",
      refuse: "Refuse",
    },
    modCname: "Modify the company name",
    modMailbox: "Modify the administrator mailbox",
    index: "index",
    oldname: "OldName",
    newname: "NewName",
    contackname: "ContackName",
    mail: "Mail",
    file: "File",
    type: "Status",
    createDate: "CreateDate",
    updateDate: "UpdateDate",
    status: "Status",
    edit: "Edit",
    app: "Approve",
    res: "Refuse",
  },
  certificate: {
    button: {
      serch: "Search",
      addbatch: "Add",
      serchcer: "SearchCertificate",
      import: "import",
      modifybatch: "MODIFY",
      delbatch: "DELETE",
    },
    batch: "Batch",
    input: "PLEASE INPUT BATCH",
    id: "ID",
    name: "CORPORATION",
    location: "LOCATION",
    username: "USERNAME",
    department: "DEPARTMENT",
    duty: "DUTY",
    tel: "TEL",
    mobile: "MOBILE",
    email: "EMAIL",
    identity: "IDENTITY",
    address: "ADDRESS",
    clevel: "LEVEL",
    trainingDate: "TRAINING DATE",
    issueDate: "ISSUE DATE",
    expireDate: "EXPIRE DATE",
    centId: "CENT ID",
    midLevel: "MID LEVEL",
  },
  mdsupload: {
    button: {
      upload: "Upload",
      view: "View",
      delete: "Delete",
    },
    status: {
      success: "Success",
      failure: "Failure",
    },
    mdsUploadSuccess:'MDS-csv Upload Success',
    mdsUploadError:'MDS-csv Upload Error',
    time: "Time",
    filename: "File Name",
    uploadstatus: "Status",
    status:"Status",
    mdsid: "MDS ID",
    uploadCount: "UploadCount",
    sample: "Match the“Sample” MDS ?",
    issamplemds: "Yes",
    notsamplemds: "No",
    cieIdError: "The specified form ID error",
    cieIdMatch: "Specifies the ID matching not successful",
    cieSymbolMatch: "Material data sheet parts / semi-finished products / materials, the match is not successful, whether to continue to upload ?",
  },
  /*信任用户*/
  trustuser: {
    sechstandard: "Search Criteria:",
    enterprises: "Enterprise:",
    query: "Search",
    trustuser: "User with confidence:",
    inputinfo:"Please give at least one search criteria!",
    orgname: "Department:",
    username: "Name:",
    email: "E-mail:",
    button: {
      query: "Search",
      cancel: "Cancel",
    },
    username2: "Name",
    enterprise: "Enterprise(department)",
    valid: "Active",
    yes: "Yes",
    no: "No",
    view: "View",
    modify: "Modify",
    modelname: "Trust user view",
    save: "Save",
    cancel: "Back",
    userInfo: "User information:",
    infoTitle: "Confidential basic substances:",
    infoContent: "Is the user allowed to see the confidential substances in your MDSs:",
  },
  //供应商查询
  supplierSearch: {
    inputQueryConditions: "Please input search criteria.",
    startDate: "Start date",
    endDate: "End date",
    dateTime: "[Year(four digits)-Month(two digits)-Day(two digits)]",
    query: "Search",
    noStartDate: "Please input Start date!",
    noEndDate: "Please input End date!",
    orgId: "Id",
    orgName: "Chinese Name of Enterprise",
    orgEname: "English Name of Enterprise",
    address: "Address",
    createDate: "CreateDate",
    userName: "User Name",
    telephone: "Telephone No.",
    email: "Email",
  },
  mdsupdate: {
    analyse_title: "MDS need to be updated",
    analyse_type: "MDS type",
    all: "All",
    com: "Component",
    semi: "Semi-component",
    mat: "Material",
    analyse_name: "Name",
    comnumber: "Number",
    id: "ID",
    analyse_analysetype: "Analysis type:",
    own: "Own",
    mds: "MDS",
    mudule: "Mudule",
    updatedate: "UpdatedDate",
    supplier_mds: "Supplier MDSs",
    approval: "Approval",
    search: "Search",
    update: "Update",
    analyse_button_cancel: "Cancel",
    number: "No",
    need_to_be_updated_cid: "MDS ID (need to be updated)",
    need_update_cver: "MDS Version (need to be updated)",
    to_be_update_cid: "MDS ID (to be updated)",
    to_be_update_cver: "MDS Version (to be updated)",
    able_to_cid: "MDS ID (able to be updated)",
    able_to_cver: "MDS Version (able be updated)",
    please_select_one: "Please select one",
    update_result: "update result",
    must_select_one: "Must select one",
  },
  // mdsResult: {
  //   index: "No.",
  //   proName: "Article Name",
  //   CproName: "Designated Name by customer",
  //   proNameForMaterial: "MdsName,>Material Symbol<",
  //   CproNameForMaterial: "designated Name by customer,>Material Symbol<",
  //   longDes: "Part/Item No., Item- /Mat.-No., Material No.",
  //   ClongDes: "Designated Component No. by customer",
  //   shortDes: "Part/Item No...",
  //   version: "Version",
  //   asCreateTime: "Creation date",
  //   mustSelect : "Please select a query result first!"
  // },
  //注册供应商
  comRedister: {
    comRedister: 'Register supplier',
    inPutComRegister0: "Pleae make sure that your supplier has not  been registered in CAMDS yet.",
    inPutComRegister: 'Please input the relevant data of supplier here. All the fields marking (<span style="color: red;">*</span>) must be filled in.',
    comData: "Supplier’s Information",
    duns: "DUNS No.:",
    dunstitle: "DUNS format is 99-999-9999",
    orgName: "Chinese Name of Enterprise:",
    orgEname: "English Name of Enterprise:",
    orgFname: "Foreign Name of Enterprise:",
    character: "forbidden character!",
    orgCode: "Institution code:",
    country: "Country/Region:",
    province: "Province/City:",
    address: "Address:",
    postCode: "Postal code:",
    companyHomepage: "Homepage:",
    companyMainProduct: "Main Business:",
    statusFlag: "Enterprise Identity:",
    statusFlag1: "Supplier",
    msg_1: "Please enter the enterprise administrator information of your supplier here.Please note that the enterprise administrator should be an employee of your supplier and not yours. This user is responsible for registering other users of his(her) enterprise.",
    msg_2: "Make sure that the enterprise administrator's e-mail is correct, because his(her) registration data will be sent to it.",
    admin: "Supplier’s Enterprise Administrator",
    name: "Name:",
    telephoneNo: "Telephone No.:",
    fax: "Fax No.:",
    email: "E-mail:",
    emailConfirm: "Email address confirm:",
    save: "Register",
    back: "Cancel",
    msg_orgName: "Please input the correct full name of enterprise.",
    msg_orgEname: "Please input the correct full name of enterprise in English. The name can not start with a number.",
    message_duns: 'Please input the DUNS number that contains nine digits.Make sure to add the connector "-" after the second digit and the fifth digit (for example, 12-345-6789).',
    msg_orgCode: "Please enter the correct tax identification number.",
    msg_address: "Please input the correct address.",
    msg_mainProducts: "Please input the Main Product.",
    msg_postCode: "please input postal code (only for numerals)",
    msg_name: "Please input the correct name of enterprise administrator",
    msg_telephoneNo: "Please input the telepone numbers(only for numerals).",
    msg_fax: "please input the fax number(only for numerals)",
    msg_email: "Please input the E-mail address (name@domain) of the Client Manager.",
    msg_emailConfirm: "The two inputed email addresses are inconsistent, please re-enter!",
    onlineInfo: "The Online Registration is completed. You will receive an e-mail with a link to your CAMDS access data. In case of problems please contact the CAMDS Service Center.",
    redisterSuccess: "Register Successfully",
    enterpriseType:"Enterprise Type",
  },
  analyseSvhc: {
    txt_file: "List upload",
    button_download: "Template",
    button_downloadSvhc: "download Svhc",
    index: "No.",
    proName: "Article Name",
    shortDes: "Part/Item No...",
    version: "Version",
    asSupply: "Supplier",
    svhc: "Contain SVHC exceed 0.1%",
    componentName: "Component Name",
    number:'number',
    uploadResult:"Upload Result",
    analyseResult:"Analyse Result",
    matchResult:"Match Result"
  },
  //用户操作日志
  queryUserLogAction: {
    loginUser: "Login name",
    company: "Enterprise",
    startDate: "Start date",
    endDate: "End date",
    operationType: "Operation type",
    query: "Search",
    exportToCsv: "Export CSV",
    exportToXls: "Export EXCEL",
    username: "User Name",
    logOperateDate: "Operation date",
    operationContent: "The detailed content of the operation",
  },
  modify: {
    modify: "Modify the specified enterprise information",
    com: "Relevant enterprise",
    search: "Search",
    inPutComRegister: 'Please input the relevant data of your enterprise here. All the fields marking (<span style="color: red;">*</span>) must be filled in.',
    comData: "Enterprise information:",
    admin: "View User",
    save: "Save",
    back: "Back",
    companyHomepage: "Homepage of enterprise:",
    companyMainProduct: "Main Business:",
    contractStartDate: "Contract start date:",
    contractEndDate: "Contract expiration date:",
    check_dateFromTo: "The start date must be earlier than the end date",
    msg_orgName: "Please input the full name of enterprise. The name can not start with a number.",
    msg_countryName: "Please input the name of country or region.",
    msg_address: "Please input the address.",
    msg_mainProducts: "Please input the main business.",
    msg_postCode: "Please input the  numbers.",
    updatesuccess: "update successful.",
    pause: "Pause",
    recovery: "Recovery",
    deregister: "Deregister",
  },
  mainpage: {
    statusFlagId: "Enterprise Identity",
    statusFlag1: "OEM",
    statusFlag2: "Supplier",
    statusFlag3: "OEM & Supplier",
    statusFlag4: "Raw material",
  },
  //企业管理员
  admin: {
    admin: "Enterprise Administrator",
    loginName: "Login name",
    name: "Name",
    telephoneNo: "Telephone No.",
    fax: "Fax No.",
    email: "Email",
    user: "User Validity",
    availability: "Valid",
    invalidation: "Invalid",
    role: "User Role",
    update: "Update",
    newAdmin: "Create enterprise administrator",
    back: "Back",
    selectRecord: "Please select an item!",
    userStatus1: "Modify User Validity",
    userStatus: "User Validity",
    tel: "tel",
    mail: "mail",
  },
  newAdmin: {
    newAdmin: "Create a administrator",
    name: "Name:",
    telephoneNo: "Telephone No.:",
    fax: "Fax No.:",
    email: "Email:",
    simpleCheckRule: "The default value of simplified check rules:",
    msg_name: "Please input the name of Client Manager.",
    msg_tel: "only for numerals.",
    msg_fax: "only for numerals.",
    msg_email: "Please input the E-mail address (name@domain) of the Client Manager.",
    createSuccess: "Create successfully",
    createSuccessInfo: "The enterprise administrator is created sucessfully. He (She) will receive an e-mail with a link to his(her) CAMDS access data. In case of problems please contact the CAMDS Service Center. ",
  },
  mdsuploadimds: {
    detect: "Check",
    materialcretetype: {
      select: "Please select",
      txt: "Material create type",
      match: "Match first",
      create: "New all",
      noselect: "Please select material create type",
      match1: "Only match materials created by my company (self-created materials)",
      match2: "Only match published materials",
      match3: "Only match standard materials",
      match4: "Matching order: self-created>>published>>standard",
      match5: "Matching order: self-created>>standard>>published",
      match6: "Matching order: published>>self-created>>standard",
      match7: "Matching order: published>>standard>>self-created",
      match8: "Matching order: standard>>self-created>>published",
      match9: "Matching order: standard>>published>>self-created ",
      match11: "Latest created time",
      match12: "Higher MDS version priority than latest created time",
      match13: "Created by the currently logged-in user\uFF08Latest created time\uFF09",
      match21: "Latest created time",
      match22: "Higher MDS version priority than latest created time",
    },
    txt: {
      xmlfile: "XML File",
      alertxmlfile: "Please select the XML file format",
      time: "Time",
      filename: "File Name",
      uploadstatus: "Status",
      reason: "Reason",
      mdsid: "MDS ID",
      mdsName: "MDS name",
      state: "Others>>",
      uploadmds: "Upload MDS",
      uploadCount: "UploadCount",
      checkerror: "Validation result"
    },
    button: {
      view: "Edit",
      delete: "Delete",
      detail: "Export Detail",
      close: "Close"
    },
  },
  //下载前搜索（IMDS转换）
  searchImds: {
    downloadMds: "downloadMds",
    mdsName: "mds name",
    symbol: "symbol",
    cid: "cid",
    cver: "version",
    latestcvel: "latest cver",
    search: "search",
    listSearch: "list Search",
    downloadTemplate: "download Template",
    download: "download",
    asSupply: "Supplier",
    asCreateTime: "Creation date",
    index: "No.",
    proName: "Article Name",
    version: "Version",
    shortDes: "Part/Item No...",
    warnID: "Please input ID",
    imdsSelect: "More than 10 MDSs are selected, it will affect the efficiency when uploading and downloading. We suggest you to choose less than 10 MDSs at a time!",
    noneSelect: "No MDS Available For Download",
    uploadFile: "Upload file",
    import: "Import",
    cancle: "cancle",
    uploadNewDocument: "upload new document",
    txt: {
      state: "other",
      uploadmds: "",
      symbol: "",
      alertcsvfile: "Please select the correct template",
    },
  },
  //scip分析
  searchMds: {
    componentName: "Article Name:",
    matNum: "Material No.:",
    matID: "ID:",
    cver: "version:",
    scipStatus: "SCIP status:",
    scipScope: "Query Scope:",
    published: "published",
    approved: "Approved",
    referenceMds: "referenceMds",
    curVersion: "Current version",
    allVersion: "All versions",
    submitted: "Submitted",
    unSubmitted: "unSubmitted",
    completed: "completed",
    failed: "approval failed",
    createBtn: "New reference",
    search: "Search",
    asSupply: "Supplier",
    asCreateTime: "Creation date",
    index: "No.",
    proName: "Article Name",
    version: "Version",
    shortDes: "Part/Item No...",
    createText: "create",
  },
  scipanalyse: {
    no: "index",
    mincomname: "Minimum components Name",
    mincomidver: "Minimum Components ID/Version",
    matname: "Material Name",
    matclassify: "Material Classify",
    matidver: "Material ID/Version",
    subname: "Basic Substance Name",
    subquality: " Basic Substance Quality(g)",
    rule: "Regulation proportion(%)",
    real: "Real proportion(%)",
    result: "Analysis Result",
    proportionInArticle:"Proportion in Article(%)",
    proportionInMaterial:"Proportion in Material（%）",
    button: {
      export: " Export",
      bom: " report",
      analyse: "Analysis",
    },
    selectRecord: "Please select an item!",
    cas: "CAS",
    ec: "EC",
  },
  // mdsSearchResult: {
  //   scipstartus: "scip status",
  //   scipstartusTime: "scip Status Time",
  //   scipnum: "scip number",
  // },
  //基础物质管理
  substanceSearchAction: {
    cname: "Name/Synonym:",
    cas: "CAS No.:",
    euIndex: "EU-Index:",
    einecs: "EC-Index:",
    class: "class:",
    gadsl: "GADSL Classification L:",
    gadslOne: "duty-to-declare",
    yes: "Yes",
    no: "No",
    notSure: "Not sure",
    gadslTwo: "Prohibited",
    reachSvhc: "REACH-SVHC:",
    svhcview: "High Concern",
    thingsId: "Substance ID",
    name: "Name",
    enName: "English name",
    search: "Search",
    insert: "Add",
    update: "Edit",
    delete: "Delete",
    choose: "Please select records",
    sureDelete: "Be sure to delete records -",
    substancemanager: "Basic substance Management",
    substanceinsert: "Basic substance Add",
    substanceModify: "Basic substance Update",
  },
  //新增基础物质
  substanceInsertAciton: {
    existNameMsg:'The name already exists',
    existEnNameMsg:'The English name already exists',
    name: "Name:",
    enName: "English name:",
    aliasOne: "Synonym 1:",
    aliasTwo: "Synonym 2:",
    aliasTh: "Synonym 3:",
    gadsl: "GADSL:",
    gadslTh: "duty-to-declare/Prohibited",
    svhcy: "Yes",
    svhcn: "No",
    groupid: "SubstanceGroup:",
    class: "Substance Class:",
    cnameCheck: "The name can not be blank",
    thingId: "Substance ID:",
    alias: "Synonym:",
    addAlias: "Add",
  },
  //CQC查询
  searchVehicleType: {
    chose: "(Please select ...)",
    choseAll: "All",
    comp: "Recipient",
    from: "From:",
    to: "To:",
    search: "Search",
    output: "Export",
    cancel: "Cancel",
    maintitle: "China Automotive Material Data System (CAMDS)",
    bad: "no suitable data",
    confirm: '"The search can be accelerated by entering additional search criteria.Continue anyway?"',
    yearday: "[Year(four digits)-Month(two digits)-Day(two digits)]",
    noresult: "no suitable data!",
    title: " query",
    check_dateType: "The date format YYYY-MM-DD is expected.",
    check_dateFromTo: "The start date must be earlier than the end date",
    fnc_chkNumber: "Please input numbers",
    statusTitle: "Status",
    dateFrom: "from:",
    dateTo: "to:",
    dateFormat: "[Year(four digits)-Month(two digits)-Day(two digits)]",
    date: "Date:",
    dateTime: "(Year(four digits)-Month(two digits)-Day(two digits))",
    status: "Status:",
    status_N: "not yet browsed",
    status_D: "Downloaded",
    doNot: "Non-accepted MDSs",
    name: "Article Name:",
    language: "Select language:",
    language_C: "Chinese",
    language_E: "English",
    language_F: "Foreign language",
    id: "ID:",
    version: "Version:",
    startDate: "Start date",
    endDate: "End date",
  },
  vehicleTypeResult: {
    createEnt: " create enterprise",
    createTime: " create time",
    // view :' view',
    copy: " copy",
    delete: " delete",
    modify: " modify",
    bomMatch: " BOM Match",
    newSearch: " new search",
    copyMsg: " Confirm to copy the model and form information",
    cancle: " cancle",
    vehicleType: " vehicleType",
    powerPlantType: " powerPlantType",
    table: "  Status sent vehicle",
    stautsTable: "Status  >>vehicle",
    page: "Page",
    pageFirst: "Previous page",
    pageNext: "next page",
    num: "No.",
    name: "Name",
    version: "ID/Version",
    status: "Status",
    view: "Preview",
    queryStandard: " Search Criteria",
    queryStandard2: ': Ordered descending by "create time"',
    watch: "View",
    modfily: "Modify",
    back: "Back",
    maintitle: "China Automotive Material Data System (CAMDS)",
    serachallrec: "Search",
    serachallrec1: "Item,",
    orderby: "search criteria: order by create time",
    pleasechose: "Please select one search criteria!",
    pagecheck: "Please input the correct Page No.",
    first: "First page",
    last: "Last page",
    di: "",
    forward: "Jump",
    item: "Item",
    searchfor: "Search for",
    screen: "Display",
    downLoad: "DownLoad",
    noneSelect: "No MDS Available For Download",
    mustSave: "Please save first",
    mustSelect: "Please select a query result first!",
    dld: "DownLoaded",
    correctPage: "Please input the correct Page No.",
    export: " export",
    wait: " wait",
    mdsMsg: " No parts have been created for this model",
    cqcExportMsg: "Make sure the data is correct before exporting ",
    deleteMsg: " Are you sure to delete this data? ",
    confirm: " Confirm",
    buildFail: "Creation failed",
    buildSuccess: "Successful Match",
  },
  MaterialExtraClass: {
    materialClassification: " Material classification",
    description: "Description",
    use: "Apply",
    cancel: "	Cancel",
    state: ">>",
    select: "Please select !",
    create: " Create",
    selectMaterClass: " Extra classification-bettery",
    secondaryClass: " Secondary Class",
    firstClass: " First Class",
  },
  vehicleTypeInfo: {
    projectName: " projectName",
    required: " required",
    powerPlantType: " powerPlantType",
    cccApplicationNo: " cccApplicationNo",
    vehicleType: " vehicleType",
    vehicleInteriorNumber: " vehicleInteriorNumber",
    vehicleTypeName: " vehicleType name",
    curbWeight: " curb weight",
    reusability: " reusability",
    EnteSh: " please enter a number",
    recyclability: " recyclability",
    okToSave: " confirm save",
    cancle: "cancle",
    title1: " create a model",
    statusTitle: "vehicle management",
    title: ">>create",
    phev: " Plug in hybrid",
    requiredMsg: 'Vehicle information:        Fields marked with(<span style="color: red;">*</span>)are required! ',
    pureElectric: " pure Electric",
    hybrid: " Hybrid",
    fuelCell: " fuelCell",
    internalCombustionEngine: " internal-combustion engine",
    saveButton: " save",
    manualMatching: " manual matching",
    BOMMatching: " BOM matching",
    export: " export",
    wait: " wait",
    button: {
      back: " return"
    },
    chakan: "View",
    detect: "Check",
    mdsMsg: " No parts have been created for this model",
    cqcExportMsg: "Make sure the data is correct before exporting ",
    uploadNewDocument: "  upload new document",
    import: " Import",
    uploadFile: " upload file ",
    saveMsg: " please save it first",
  },
  //材料数据表统计
  mdsStatistics: {
    title: "MDS Statistics",
    search: "Search",
    orgName: "Enterprise/Department:",
    orgName1: "Enterprise/Department",
    start: "Deadline:",
    isSelf: "Statistics Type:",
    self: "Own",
    send: "Sent",
    receive: "Received",
    ent: "Enterprise",
    entid: "ID",
    postCode: "Zip Code",
    city: "City",
    country: "Country/Region",
    formSatus: "MDS Status",
    where: "Search Criteria:",
    n: "not yet browsed",
    s: "browsed",
    p: "Accepted",
    c: "Canceled by sender",
    r: "Rejected",
    d: "DownLoaded",
    subTitle: "Status received MDSs",
    subTitle1: "Status sent MDSs",
    level2Title: "Received MDSs",
    level2Title1: "Sent MDSs",
    queryStandard2: 'Ordered descending by "reception time"',
  },

  /*菜单-跟踪*/
  traceMds: {
    name: "Material name",
    version: "ID/Version",
    code: "Component No., SemiComponent No., Material No.",
    deadLine: "Follow-up date",
    traceStauts: "Follow-up",
    mdsStatus1: "Edit mode",
    mdsStatus2: "not yet browsed",
    mdsStatus3: "Browsed",
    mdsStatus4: "Accepted",
    mdsStatus5: "Rejected",
    mdsStatus6: "Canceled by the sender",
    mdsName: "MDS name",
    remark: "Remark",
    traceDetails: "Trace Details",
  },
  receivesearch: {
    mdsType: "MDS type",
    name: "Designated Name",
    version: "ID/Version",
    code: "Designated Component No.",
    sendTime: "Reception time",
    approveTime: "Approve time",
    statusChangeTime: "Status Change Time",
    sendOrg: "Original enterprise (department)",
    sendOrgID: "Original enterprise ID",
    status: "Status",
    nsen: "Not yet browsed",
    acpt: "accepted",
    modi: "modified",
    prec: "In process recipient",
    seen: "browsed",
    recd: "rejected",
    showTable: 'Displayed columns',
    dld: "DownLoaded",
    cbs: "Canceled by sender",
    commitment: "Commitment",
    commitmentMsgN: "no",
    commitmentMsgY: "yes",
    complianceinfo: "Commitment",
    view: "Preview",
    watch: "View",
    favorite: "Folder",
    analyse: "Analyze",
    trace: "Follow up",
    back: "New Search",
    approveMds: "Accept",
    refusedMds: "Reject",
    downLoad: "DownLoad",
  },
  forwardData: {
    forwardDataText: "analyse Svhc",
    txt: {
      state: "analyse",
      forwardData: " forwardData",
      file: "List upload"
    },
    mdsName: "mds name",
    symbol: "symbol",
    cid: "cid / version",
    cver: "version",
    latestcvel: "latest cver",
    search: "search",
    asSupply: "Supplier",
    asCreateTime: "Creation date",
    index: "No.",
    proName: "Article Name",
    version: "Version",
    versionmdsNname: "mds name",
    shortDes: "Part/Item No...",
    finded: "Search for",
    count: "Item(s)",
    show: "Display",
    page: "Pages",
    button: {
      browse: "Browse",
      upload: "Upload",
      download: " Template",
      downloadSvhc: " download Svhc",
    },
    uploadNewDocument: "  upload new document",
    import: " Import",
    uploadFile: " upload file ",
    cancle: "cancle",
    // wait: " wait",
    listSearch: "List Upload",
    imdsSelect: "More than 10 MDSs are selected, it will affect the efficiency when uploading and downloading. We suggest you to choose less than 10 MDSs at a time!",
    noneSelect: "No MDS Available For Download",
    maskLayer: "Data is being processed, please wait ...",
    svhc: "Contain SVHC exceed 0.1%",
    wait: " wait",
    mdsNname: " mds name",
    // symbol: " symbol",
    recMdsname: " recMdsname",
    recSymbol: " recSymbol",
    suppliercode: " suppliercode",
    recOrgId: " recOrgId",
    batch: " batch",
    forwardMdsId: " New Id / version",
    status: " status",
    reason: " reason",
    correctPage: "Please input the correct Page No.",
  },
  sendsearch: {
    back: "Back",
    name:"Name",
    modfily: "Modify",
    code: "Component No., SemiComponent No., Material No.",
    csymbol: "Designated Component No. by customer",
    sendTime: "sent time",
    sendOrg: "recipient enterprise(department) [ID]",
    dld: "DownLoaded",
    modi: "modified",
  },
  mdsStatisticsSend: {
    n: "not yet browsed",
    s: "browsed",
    p: "Accepted",
    c: "Canceled by sender",
    r: "Rejected",
    d: "DownLoaded",
  },
  mdsStatisticsSelf: {
    all: "All",
    ed: "Edit mode",
    ir: "Internally released",
    sd: "Sent",
    st: "Proposed",
    rl: "Published",
  },
  //计费节点统计
  countpoint: {
    supplierText: "search enterprise",
    type: "Type",
    zhengche: "OEM billing",
    cai: "CAI uploading billing",
    csv: "CSV uploading billing",
    ic: "IC uploading billing",
    entname: "enterprie name",
    all: "All",
    search: "Search",
    count: "Quantity",
    ge: " ",
  },
  //分类分析
  analyse: analyse.EN,
  //创建请求
  mdsdatacreate: {
    cproject: 'Project',
    crecpeople: 'MDS  Supplier',
    search: 'Search',
    mdsdatatype: 'MDS type',
    mdspart: 'Component',
    mdshalfpart: 'SemiComponent',
    mdsmaterial: 'Material',
    csendpeople: 'MDS Recipient (Requester)',
    mdscdeadline: 'Deadline',
    requeststatus: 'Request status',
    hadsave: 'Saved',
    havenotsave: 'not saved',
    spanmsg: 'Predetermined specific recipient information',
    partNo: 'Designated Component No. by customer',
    reportNo: 'Report No.',
    rdName: 'Designated Name by customer',
    reportdate: 'Report date',
    drawingNo: 'Drawing No.',
    purChaseOrderNo: 'Purchase order No.',
    drawingDate: 'Drawing date',
    billOfLadingNo: 'Bill of delivery No.',
    drawingModCodeNo: 'Drawing Change Level',
    csupplierCode: 'Supplier code',
    reMark: 'Remark',
    rollback: 'Back',
    save: 'Save',
    NotForSelfEntprise: 'You may not send a MDS Request to yourself.',
    mustinput: 'Please input all of the required data:',
    dateerror: 'Date format error! [Year(four digits)-Month(two digits)-Day(two digits)] is excpected.',
    cdeadLineAfterSysteDate: 'The deadline date must be later than the current one.',
    sent: 'Send',
    savemessage: 'You have not saved the data. Are you sure to continue the operation?',
    datahadsave: 'Saved sucessfully!',
    datahadsend: 'Send sucessfully!'
  },
  svhc: {
    assemblyPart: "Assembly Part Name",
    assemblyPartID: "Assembly part ID/version",
    assemblyPartNum: "Supplier Number",
    supplierName: "Supplier Name",
    part: "Part Name",
    partId: "Part Id/Version",
    materialName: "Material Name",
    materialClassify: "Material classification",
    materialId: "Material Id/Version",
    substanceName: "Substance Name",
    substanceContent: "Substance Content(g)",
    lawsProportion: "Regulation Proportion(%)",
    proportionInMaterial:"Proportion in Material（%）",
    realProportion: "Actural Proportion(%)",
    analysisResult: "Analysis result",
  },
  scip: {
    scipName: "Article name:",
    symbol: "Primary article identifier type:",
    newNodeType: "Node type",
    concernElement: "Concern element",
    candidateListSubstance: "SVHC Substance",
    concentrationRange: "Concentration range",
    materialCategories: "Material category",
    mixCategories: "Mixture category (EUPCS)",
    extraCategories: "Additional material characteristics:",
    attachedDocuments:"File"
  },

  // 导航栏
  navData: {
    // 首页
    homepage: "Home Page",
    //数据管理
    dataAdministration: "Data Management",
    essentialData: "Basic Data  Download",
    MDSData: "MDS Data Download",
    LocalData: "Local Data Synchronization",
    auditDistribute: "Task Distribution",
    auditInfo: "Audit Info",
    // 系统管理
    systemManage: "System Management",
    DepartmentManage: "Department Info",
    UserManage: "User Info",
    PersonalManage: "Personal Info",
    RoleManage: "Role Info",
    LogManage: "Log Info",
    ConfigurationManage: "Configuration Info",
    //SCIP对接
    scipDocking: "SCIP management",
    vehicleSVHCAnalysis: "The vehicle SVHC analysis",
    SCIPNotification: "SCIP Bulletin",
    //车型管理
    VehicleManagement: "Vehicle Management",
    ModelInformation: "Model Info",
    ModelBOMInformation: "BOM Info",
    ModelChange: "Model Change/Extend",
    PartsChange: "Parts Change",
    PartsExtend: "Parts Extend",
    DangerManage: "High-Risk Parts Reporting",
    // 综合分析
    analysisBySynthesis: "Comprehensive Analysis",
    materialAnalysis: "Material Analysis",
    partMaterialAnalysis: "Part Material Analysis",
    rbsAnalysis: "RBS Analysis",
    rbsExemptionAnalysis: "RBS Exemption Analysis",
    componentRRRCalculation: "RRR Component Calculation",
    RRRcalculationOfTheVehicle: "RRR Vehicle Calculation",
    RRRlabelingAndScreening: "RRR Mark Filtering",
    reportToManagement: "Report Management",
    // 规则管理
    ruleManagement: "Rule Management",
    reviewTheRules: "Review Rules",
    regulatoryInformation: "Laws Info",
    taggingRules: "Marking Rules",
    //信息管理
    informationManagement: "Info Management",
    fileManagement: "File Management",
    messageReminding: "Message Reminding",

    //cqc
    fillCQC: "CQC management",
  },
  placeholder: {
    dataselect: "Please Select",
    datainput: "Please Input",
    datainputLanguage: "Please Input Language",
    none: "none",
  },
  message: {
    text:"Message",
    deleteAll: "Delete All",
    messageType:"Message Type",
    messageAll:"All messages",
    messageCustomer:"Customer push messages",
    messageSystem:"System push messages",
    messageMds:"MDS push messages",
    messagePush:"Push",
    confirmMessagePush:"Are you sure about the push?",
    messageEnterprise:"Enterprise related news",
    messagePublicly:"Publicly release information",
    messageDisclosureAndPush:"Message Disclosure And Push",
    systemUpdatePush:"System Update Push",
    pushRecords:"Push Records",
    regulatoryUpdatePush:"Regulatory Update Push",
    customerRequestsPushNotifications:"Customer Requests PushNotifications",
    PushLinkAddress:"Push link address",
    PushTargetSuppliers:"Push target suppliers",
    NoPushTargetSuppliersTips:"Push target supplier cannot be empty",
    customerContactInformation:"Customer contact information",
    alreadyViewed:"Already viewed",
    notBrowsed:"Not browsed",
    replied:"Replied",
    checkDeleteAll: "Do you confirm delete all the messages?",
    num: "No.",
    date: "Creation date",
    content: "Contents",
    link:'Link location',
    send: "Senders",
    company: "Enterprise",
    org: "Department",
    delisok: "Delete successful!",
    unableToApprove: "Form validation error data cannot be approved!",
    replaced: "Unable to edit the current node!",
    submitECHAnotSupport: "This module is not developed yet, so stay tuned!",
    goscip: "BOM generated successfully! Do you want to go to the SCIP notification page to fill in the information？",
    chachError: "Failed verification, cannot export!",
    downloadSuccess: "Success!",
    selectOne: "Please select a piece of data!",
    mustFill: "Please Fill In The Required Fields!",
    selectStatus: "Please select data with the same data status!",
    deleteSuccess: "successfully delete!",
    formError: "Do not fill in the required fields or fill in the error!",
    editSuccess: "Success!",
    addSuccess: "Success!",
    uploadSuccess: "Success!",
    formatError: "File format error, Please check!",
    loding: "loading...",
    approve: "Confirm Approval?",
    ReviewTheSuccess: "Success!",
    ReCheckSuccessful: "Success!",
    BOM_structure: "Select data with the same data state and no BOM structure!",
    Copy: "Success!",
    afterBOMlocked: "After the BOM is locked, it cannot be edited and deleted. Is it locked or not?",
    afterBOMunlocked: "After the BOM is unlocked, it can be edited and deleted. Please confirm whether it is unlocked or not.",
    lock: "Success!",
    unlock: "Success!",
    oneFile: "Only one file can be uploaded, please delete the file before uploading!",
    fileType: "Support Word, Excel, PPT, PDF files",
    success: " Success!",
    PasswordResetTo: "Password reset to",
    confirmWhetherToReset: ", confirm whether to reset?",
    ResetSuccess: "Success!",
    twoPassword: "The two passwords do not match!",
    remark: "Note: Updated daily",
    annotatedsuccess: "Success!",
    selectnode: "Please select node!",
    cannotFilled: "The current node cannot be filled!",
    unannotated: "The current node cannot be unannotated!",
    cancellation: "Confirm the cancellation?",
    CancelSuccessful: "Success!",
    annotated: "The current node cannot be annotated!",
    cancelling: "Confirm cancelling harmful label?",
    cancellationsuccessful: "Harmful label cancellation successful!",
    Confirmthecancellation: "Confirm the cancellation of recycling information labeling?",
    cancelledSuccessfully: "Success!",
    cannotBeAdded: "The current node cannot be added!",
    CannotEditRoot: "Cannot edit the root node!",
    cannotEdited: "The current node cannot be edited!",
    notDeleted: "The root node could not be deleted!",
    cannotdeleted: "The current node cannot be deleted!",
    Cannotrootnode: "Cannot hook the root node!",
    nothooked: "The current node could not be hooked!",
    Nodatafound: "No data found!",
    Pleasequery: "Please query!",
    selectApiece: "Please select a piece of data!",
    onepieceofdata: "You can only select one piece of data!",
    datainvalid: "Current data is invalid!",
    notApproved: "Current data is not approved!",
    analysisnode: "Please select the analysis node!",
    substanceAnalysis: "Please select parts!",
    clearlabel: "Do you want to clear the label?",
    clearlabelsuccessfully: "Success!",
    verificationSuccessful: "Success!",
    markComplete: "Completely!lock or not?",
    uploadFile: "Please upload the file!",
    Currently: "Currently, only the previous day’s data can be synchronized!",
    time_consuming: "Full synchronization, time-consuming!",

    FillUserName: "Please fill in the user name!",
    FillPassword: "Please fill in your password!",
    FillCompanyID: "Please fill in your company ID!",
    matchingSuccess: "Success!",
    uploadSize: "Upload file size 50M Max!",
    ConfirmDownload: "Confirm download?",
    range: "The range is 0-100!",
    maximumGreater: "The maximum must be greater than the minimum!",
    minimumGreater: "The minimum must be less than the maximum!",
    UnableEdit: "Unable to add editing or invalid components!",
    beenLoaded: "All data has been loaded!",
    ReleaseSuccess: "Success!",
    CannotReplaceTheComponent: "Cannot replace an editable or invalid component!",
    SynchronizationStatusSuccessful: "Success!",
    currentSynchronizeTheState: "The current data cannot synchronize the state!",
    InquireNoThisSubstance: "Query no this substance!",
    locateTheNodeFirst: "Please locate the node first!",
    selectDepartmentInformation: "Please select department information!",
    selectTheMDSContact: "Please select the MDS contact!",
    matchingSuccessful: "Success!",
    CQCsuccessfully: "Success!",
  },
  reg: {
    phone: "Please enter the correct phone number!",
    email: "Please enter the correct email address!",
    deptId: "Up to 10!",
  },
  tableWidth: {
    cidCver: "160",
    csymbol: "154",
    cname: "200",
    ccreator: "180",
    cstatus: "154",
    setflagInfo: "154",
    cauditInfo: "154",
    time: "200",
    capproveDate: "230",
  },
  tableOptionWidth: {
    camdsDataAdmin_main: "250",
  },
  mdsSearchResult: {
    mustSelect: "Please select a query result first",
    correctPage: "Please enter the correct page number",
    searchMds: "SCIP ANALYSIS",
    result: "MDS query results",
    reBack:'return',
    search: "MDS ANALYSIS",
    accord: "Accord",
    asName: "Name",
    asNumber: "Number",
    asSupply: "Supply",
    asCreateTime: "CreateTime",
    desc: "Desc",
    asc: "Asc",
    order: "order",
    checkout: "Check Out",
    modify: "modify",
    copy: "copy",
    delete: "delete",
    favorite: "favorite",
    preview: "preview",
    analyze: "analyze",
    newSearch: "newSearch",
    index: "index",
    proName: "Product name",
    CproName: "Supply name",
    proNameForMaterial: "NameC>Material identification<",
    CproNameForMaterial: "Supply name,>Material identification<",
    longDes: "ComponentsNum,Semi-components Num,Material Num",
    ClongDes: "Supply No",
    shortDes: "ComponentsNum,semi...",
    refstandard: "refstandard",
    version: "ID / version",
    finded: "finded",
    count: "count",
    show: "show",
    page: "page",
    downLoad: "downLoad",
    downLoadImds: "downLoadImds",
    noneSelect: "noneSelect",
    Selected: "Selected material data tables total",
    maxCount: "Download up to 50 records at a time",
    maskLayer: "Processing data, please wait...",
    complianceinfo: "complianceinfo",
    deleteAlert: "It has been downloaded and cannot be downloaded",
    overdue: "overdue",
    overdeMsg: "The MDS marked as obsolete would not be allowed for future submissions anymore.",
    effective: "Mark as valid",
    effectiveMsg: "Mark as valid",
    reach: "REACH Report",
    imdsSelect: "More than 10 MDSs are selected, it will affect the efficiency when uploading and downloading. We suggest you to choose less than 10 MDSs at a time!",
    mdsType: " mdsType",
    scipAnalysis: "Scip Analysis",
    scipstartus: " scip status",
    scipstartusTime: " scip Status Time",
    scipnum: "scip number",
  },
  scipSearchResult: {
    button: {
      status: " status"
    },
    NotAnalyzed: " Not Analyzed",
    NotBlank: "Information cannot be empty",
    status: " status",
    scipNumber: " scipNumber",
    reportUrl: "reportUrl ",
    commitMsg: " It is not recommended to modify or re-notify the data that has already been notified to SCIP",
  },
  folder: {
    dialogTitle1:"Add folder",
    dialogTitle2:"Edit folder",
    delmdsmsg:"Are you sure to remove this MDS from the folder?",
    dialogMDSTitle:'Find and locate',
    suremsg: "	Are you sure to delete this folder and all the data in it?",
    savemsg: "	You have not saved it. Do you want to save it now?",
    delmdsmsg: "	Are you sure to remove this MDS from the folder?",
    selectresult: "	Please select a query result first!",
    selectfolder: "	Please select a folder first!",
    hadsave: "	Save sucessfully!",
    mdsfoldermanage: "	MDS classification management",
    mdsfolderother: "	classification management",
    foldermanage: "	MDS classification management",
    folderadd: "	Add",
    del: "	Delete",
    edit: "	Edit",
    folderfindmds: "MDS Search",
    watch: "View",
    update: "	Modify",
    remove: "	Remove",
    copy: "	Copy",
    favorite: "Folder",
    preview: "	Preview",
    analyze: "	Analysis",
    foldername: "Directory name",
    createtime: "	Creation time",
    entname: "	Enterprise name",
    creatername: "	Creator name",
    reMark: "	Note",
    findnodata: "	No result available!",
    returnmsg: "	The folder choosen does not exist or has not been saved!",
    hasSame: "This Mds has already exist !",
    editmdsversion: "	This data belong to official version and can not be edited!",
    hasExist: "The name has already exist!",
    notNull: "The name can not be null!",
    save: "	Save",
    cancel: "	Cancel",
    firstsave: "Please save or delete the node\!"
  },
  popfolder: {
    msg: "Please select a directory!",
    hadsave: "Saved sucessfully!",
    mdsfoldermanage: "MDS classification management",
    mdsfolderother: "classification management",
    foldermanage: "MDS classification management",
    addtofolder: "Add to folder",
    save: "Save",
    cancel: "Cancel"
  },
  copyMds: {
    copyType: "Select copy type",
    forward: "Forwarding",
    newVersion: "New version",
    copy: "Copy",
    continue: "Continue",
    notice: " This MDS has been removed. Do you want to continue?",
    cancel: "Cancel",
    title: "Copy MDS",
    pleasewait: "Please wait a moment",
    version: "Version"
  },
  editmds: {
    treeOperation: "Tree Operations",
    findAndOrientation: "Search and Locate",
    filterTreeName: "Article Name",
    filterFind: "Filter",
    fuzzyQuery: "Fuzzy Query",
    accurateQuery: "Accurate Query",
    filterTreeCode: "Part/Item No……",
    filterTreeCodeAll:"Part/Item No., Item- /Mat.-No., Material No.",
    filterTreeId: "ID",
    version: "ID/Version",
    filterTreeCAS: 'CAS',
    filterNoLoadSub: 'Do not load any Basic Substance',
    filterNoLoadRef: 'Do not load referenced MDSs/Modules',
    filterTree: 'Filter ',
  }
};
